/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Force_Takeover_MsgInputs */



/**
* | output |
* | --- |
* | "Moves the offline lock to this device. Changes not yet uploaded from the other device are lost." |
*
* @param {Offline_Force_Takeover_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_force_takeover_msg = /** @type {((inputs?: Offline_Force_Takeover_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Force_Takeover_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transfère le verrou hors ligne sur cet appareil. Les modifications pas encore envoyées depuis l'autre appareil sont perdues.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pasa el bloqueo sin conexión a este dispositivo. Los cambios aún no subidos desde el otro dispositivo se pierden.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Passa o bloqueio offline para este dispositivo. Mudanças ainda não enviadas do outro dispositivo se perdem.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta il blocco offline su questo dispositivo. Le modifiche non ancora inviate dall'altro dispositivo vanno perse.")
	return /** @type {LocalizedString} */ ("Moves the offline lock to this device. Changes not yet uploaded from the other device are lost.")
});